import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageGameStatus } from '../voyageGameStatus-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageShipStatus {
  oxygen: number
  power: number
  jump: number
}

export const voyageMessageId = EVoyageMessage.ShipStatus

export function write(m: IMessageWriter, d: IMessageShipStatus) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.writeFloat(m, d.oxygen)
  messageWriter.writeFloat(m, d.power)
  messageWriter.writeFloat(m, d.jump)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)
  let d: IMessageShipStatus = {
    oxygen: messageWriter.readFloat(m),
    power: messageWriter.readFloat(m),
    jump: messageWriter.readFloat(m),
  }
  return d
}

export function test() {
  let ex: IMessageShipStatus = {
    oxygen: 120.123,
    power: 110.25,
    jump: 254.23,
  }
  messageWriter.test('ship-status', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  voyageGameStatus.networkUpdate(msg)
}

export function sendMessageAndImmediatelyExecute(msg: IMessageShipStatus) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
